export enum SocialListTypeEnum {
  FOLLOWS = 'FOLLOWS',
  REACTIONS = 'REACTIONS',
  EVENTS = 'EVENTS',
  EVENT_PARTICIPANTS = 'EVENT_PARTICIPANTS',
  PROJECT_EVENTS = 'PROJECT_EVENTS',
}
